var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.8895 0 0 5.92683 0 13.2439C0 16.1707 0.933702 18.878 2.51381 21L4.23757 19.5366C3.01657 17.7805 2.29834 15.5854 2.29834 13.2439C2.29834 7.2439 7.03867 2.34146 13 2.34146C18.9613 2.34146 23.7017 7.17073 23.7017 13.2439C23.7017 15.5854 22.9834 17.7805 21.7624 19.5366L23.4862 21C25.0663 18.8049 26 16.1707 26 13.2439C26 5.92683 20.1823 0 13 0ZM17.7403 7.90244L11.3481 15.3659C10.8453 16.3171 11.1326 17.4878 12.0663 18C13 18.5122 14.1492 18.2195 14.6519 17.2683L17.7403 7.90244Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.4aadcfdf9c6122e1a5287cf9cf6294d0.svg";
export { ForwardRef as ReactComponent };